<template>
    <AppLayout>
        <h2 class="text-lg font-medium mb-2">{{ $t("tenants.title") }}</h2>

        <button-primary class="mb-3" @click="showCreateModal = !showCreateModal"
            >{{ $t("tenants.buttons.new") }}
        </button-primary>

        <tenant-create
            :errors="errors"
            :error-bags="errorBags"
            :modal="showCreateModal"
            @close="showCreateModal = false"
        />

        <tenant-update
            :error-bags="errorBags"
            :errors="errors"
            :tenant="$props.tenant"
            :show-modal="showUpdateModal"
            @close="showUpdateModal = false"
        />

        <Table :headers="['id', 'name', 'updated_at', 'actions']" :content="tenants.data" />
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import TenantCreate from "@/Pages/Universal/TenantCreate";
import TenantUpdate from "@/Pages/Universal/TenantUpdate";
import ButtonPrimary from "@/Components/ButtonPrimary";
import Table from "@/Components/Table";
import { reactive, ref } from "vue";

export default {
    name: "Tenant",
    components: {
        TenantUpdate,
        ButtonPrimary,
        TenantCreate,
        AppLayout,
        Table,
    },
    props: {
        tenants: Object,
        tenant: Object,
        errorBags: Object,
        errors: Object,
        modal: String,
    },
    setup(props) {
        const showCreateModal = ref(false);
        const showUpdateModal = ref(false);

        const data = reactive({
            currentTenant: false,
        });

        if (props.modal === "Universal/Tenant/TenantUpdate") {
            showUpdateModal.value = true;
        }

        data.currentTenant = false;
        if (props.tenant) {
            // eslint-disable-next-line vue/no-setup-props-destructure
            data.currentTenant = props.tenant;
        }

        return { showUpdateModal, showCreateModal, data };
    },
};
</script>
